import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/LisaNewell/subs.vtt';
import poster from '@/static/assets/reviews/LisaNewell/video.jpg';

export const LisaNewell: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Lisa',
  videoUrl: `${ASSETS_URL}/pet/LisaNewell_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
